import React from 'react';
import {Backdrop, createStyles, Theme} from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';
import "./index.scss";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1
        }
    })
);

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export const AboutPopup = ({isOpen, onClose}: Props) => {
    const classes = useStyles();

    return (
        <div>
            <Backdrop open={isOpen} className={classes.backdrop}>
                {process.env.REACT_APP_LANG === "ua" ?
                    <div className={"about-popup"}>
                        <button className="close" onClick={onClose} aria-label="Close"/>
                        <div className="about">
                            <div id="who_we_are" className="about-text">
                                <div className="container">
                                    <div className="inner">
                                        <h2><span>ARX</span> – це впевненість</h2> 
                                        <p>{/*Страхова
                                        компанія
                                        ARX – частина міжнародної канадської страхової групи Fairfax Financial Holdings.
                                        25
                                        років успішно працюємо на ринку України, 11 з яких під брендом АХА Страхування.
    <br/><br/>*/}
                                        Коли світ нестабільний, лише впевненість допомагає клієнтам сконцентруватись на
                                        майбутньому, на його створенні, на досягненнях. Ми надаємо нашим клієнтам
                                        можливість
                                        думати не про проблеми, які ми вирішимо, а про досягнення. Ми прозора компанія,
                                        що
                                        завжди відкрита до діалогу. Ми впевнені, що саме так можна вибудувати дружні та
                                        чесні відносини з кожним клієнтом.</p></div>
                                </div>
                            </div>
                            <div id="arx_in_numbers" className="about-numbers">
                                <div className="container container-lg">
                                    <div className="about-numbers-bg">
                                        <div className="inner"><h4><span>Справи</span> – ось що важливо</h4> <p>Цифри
                                            підтверджують наші досягнення, а ми гарантуємо вам впевненість.</p>
                                            <div className="about-numbers-wr">
                                                <div className="item">
                                                    <div className="item-label">&gt;5,4<span> млн.</span></div>
                                                    <div className="item-descr">грн виплачували щодня нашим клієнтам за результатами 2021 року
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="item-label">№1</div>
                                                    <div className="item-descr">на ринку КАСКО 11 років поспіль, за результатами 2021 року</div>
                                                </div>
                                                <div className="item">
                                                    <div className="item-label">95<span>%</span></div>
                                                    <div className="item-descr">клієнтів КАСКО "Все включено" задоволені врегулюванням страхової події у 2021 році
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="item-label">2,5<span>млн.</span></div>
                                                    <div className="item-descr">договорів, укладених в 2021 році</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="improve" className="about-text about-text-sml">
                                <div className="container">
                                    <div className="inner">
                                        <div className="label">Ми вдосконалюємо</div>
                                        <h3>Та розвиваємо наші онлайн сервіси</h3> <p>Страхові випадки ми врегульовуємо
                                        дистанційно, щоб нашим клієнтам не потрібно було їздити із паперовими
                                        документами по
                                        всьому місту. Здійснити черговий платіж, оформити автоцивілку та туристичне
                                        страхування у нас можна онлайн всього за 6 хвилин.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :

                    <div className={"about-popup"}>
                        <button className="close" onClick={onClose} aria-label="Close"/>
                        <div className="about">
                            <div id="who_we_are" className="about-text">
                                <div className="container">
                                    <div className="inner"><p> We are a software development company
                                        located in Kyiv, Ukraine.
                                        We are 45 full-time,
                                        in-house professionals providing solutions based on
                                        technology, creativity and innovation.
                                        <br/><br/>
                                        Our experience in cutting-edge technology
                                        and the insurance business domain allows us
                                        to help our clients on its digitalization path.
                                        <br/><br/>
                                        Flexibility to work
                                        A dedicated account manager will discuss your goals and challenges.
                                        Whether hiring one or many, we help you find the right talent right now.
                                        <br/><br/>
                                        Level up career
                                        Work with internationally recognized clients
                                        and take ownership of how you work to build things.
                                        <br/><br/>
                                        We learn, teach, and mentor
                                        We skilled to solve the most challenging business problems thanks from our
                                        curiosity
                                        and the varied experiences of our team.
                                        <br/><br/>
                                        We love fun
                                        We are always ready to have fun! We love outdoor activities.
                                        Rock climbing, rafting and other active entertainment - this is about us.
                                        And our holiday parties always leave an unforgettable experience!
                                        <br/><br/>
                                        We are for talent
                                        We believe that every person is talented.
                                        And we give everyone the opportunity to develop their talents.
                                        We learn and grow together.</p></div>
                                </div>
                            </div>

                        </div>
                    </div>
                }
            </Backdrop>
        </div>
    )
};